(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["elova-size-guide-trigger"] && !Shopify.designMode) return;
  try {
    class ElovaSizeGuide extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.elova-size-guide__trigger');
      this.dialog = this.querySelector('dialog');
      this.closeBtn = this.querySelector('.elova-size-guide__close');

      if (!this.trigger || !this.dialog) return;

      this.trigger.addEventListener('click', this.open.bind(this));
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));

      this.dialog.addEventListener('click', this.handleBackdrop.bind(this));
      this.dialog.addEventListener('close', this.afterClose.bind(this));
    }

    open() {
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
      this.lastFocus = document.activeElement;
      requestAnimationFrame(() => {
        if (this.closeBtn) this.closeBtn.focus();
      });
    }

    close() {
      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
        this.afterClose();
      }
    }

    afterClose() {
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus();
      }
    }

    handleBackdrop(event) {
      if (event.target === this.dialog) this.close();
    }
  }

  if (!customElements.get('elova-size-guide')) {
    customElements.define('elova-size-guide', ElovaSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
